import { render, staticRenderFns } from "./pressreleases.vue?vue&type=template&id=e19a3836&scoped=true&"
import script from "./pressreleases.vue?vue&type=script&lang=ts&"
export * from "./pressreleases.vue?vue&type=script&lang=ts&"
import style0 from "./pressreleases.vue?vue&type=style&index=0&id=e19a3836&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e19a3836",
  null
  
)

/* custom blocks */
import block0 from "./pressreleases.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VImg,VRow})
